import React from "react";
import { StringWidget } from "./StringWidget";

export function MLStringWidget(props) {

  const actionButtonOptions =
  {
    icon: 'font',
    action: (value) => {
      alert("TBD");
    }
  };

  return (
    <StringWidget
      isBaseWidgetFor="MLStringWidget"
      actionButtonOptions={actionButtonOptions}
      {...props}
    />
  );
}